import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import Modal from './Modal';
import useIsDashboardEnabled from '../hooks/useIsDashboardEnabled';
import Anchor from '../Anchor';

function WaitingApprovalModal({ t, closeModal }) {
  const isDashboardEnabled = useIsDashboardEnabled();

  return (
    <Modal id="completed-order-modal">
      <div
        className="modal-dialog modal-dialog-centered modal-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="m--font-inverse-primary">
              {t('academy.modal.waitingForApprovalTitle')}
            </h3>
          </div>
          <div className="modal-body">
            <div className="modal-text">
              <div>{t('academy.modal.waitingForApproval')}</div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="footer-buttons">
              <div className="footer-single-button">
                {isDashboardEnabled && (
                  <Anchor
                    className="btn m-btn--pill btn-dynamic btn-success-modal"
                    href="/dashboard"
                  >
                    {t('dashboard')}
                  </Anchor>
                )}
              </div>
              <div className="footer-single-button">
                <Anchor
                  className="btn m-btn--pill btn-dynamic btn-success-modal"
                  onClick={closeModal}
                >
                  {t('close')}
                </Anchor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

WaitingApprovalModal.propTypes = {
  t: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default translate(WaitingApprovalModal);
